import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CategoriasComponent } from './categorias/categorias.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { ReaderComponent } from './reader/reader.component';
import { PerfilComponent } from './perfil/perfil.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { adminGuard } from './guards/admin.guard';
import { LoginComponent } from './login/login.component';
import { RegistroComponent } from './registro/registro.component';
import { noroleGuard } from './guards/norole.guard';
import { authGuard } from './guards/auth.guard';
import { MangaPreviewComponent } from './manga-preview/manga-preview.component';
import { MisobrasComponent } from './misobras/misobras.component';
import { AgregarhojasComponent } from './agregarhojas/agregarhojas.component';
import { AdminComponent } from './admin/admin.component';
import { AdminUsersDetailsComponent } from './admin-users-details/admin-users-details.component';


export const routes: Routes = [
    { path: '',component:HomeComponent},
    { path: 'Preview', component: MangaPreviewComponent},
    { path: 'categorias', component: CategoriasComponent },  // Ruta para Categorías,
    { path: 'subirarchivo', component:FileUploaderComponent},
    { path: 'reader', component: ReaderComponent},
    { path: 'perfil/user/:id', component: PerfilComponent, canActivate: [authGuard]},
    { path: 'edit-profile/user/:id', component: EditProfileComponent},
    { path: 'login', component: LoginComponent },
    { path: 'signup', component: RegistroComponent},
    {path: 'registrodeobra', component: MisobrasComponent, canActivate: [authGuard]},
    {path: 'agregarhojas', component: AgregarhojasComponent, canActivate: [authGuard]},
    {path: "admin", component: AdminComponent},
    {path: 'admin/user/:id', component: AdminUsersDetailsComponent, canActivate: [authGuard]}
   ]; // Ruta para Formulario de Registro
